import React, { useContext } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { AuthContext } from '../App'; 
import { LogOut } from 'lucide-react';
import './header.css';

function Header() {
  const navigate = useNavigate();
  const location = useLocation();
  const { logout, user } = useContext(AuthContext);

  const handleLogout = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    
    // Show confirmation
    if (!window.confirm('Are you sure you want to logout?')) {
      return;
    }
    
    try {
      console.log('Logging out...');
      await logout();
      navigate('/', { replace: true });
    } catch (error) {
      console.error('Logout failed:', error);
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      localStorage.removeItem('permissions');
      window.location.href = '/';
    }
  };

  // Get page title from path
  const getPageTitle = (pathname) => {
    const path = pathname.slice(1);
    if (!path) return 'Dashboard';
    if (path === 'home') return 'Dashboard';
    return path.split('-').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
  };

  const pageTitle = getPageTitle(location.pathname);
  const initials = user?.name ? user.name.substring(0, 2).toUpperCase() : 'U';
  const isOwner = user?.role === 'owner';

  const handleAvatarClick = () => {
    if (isOwner) {
      navigate('/settings');
    }
  };

  return (
    <header>
      <div className="header-left">
        <h2 className="header-title">{pageTitle}</h2>
      </div>

      <div className="header-right">
        <div className="user-profile">
          <div className="user-info">
            <span className="user-name">{user?.name || 'User'}</span>
            <span className="user-role">{user?.role || 'Role'}</span>
          </div>
          <div
            className="user-avatar"
            onClick={handleAvatarClick}
            title={isOwner ? 'Settings' : undefined}
            style={isOwner ? { cursor: 'pointer' } : {}}
          >
            {initials}
          </div>
        </div>

        <button className="logout-btn" onClick={handleLogout} title="Logout">
          <LogOut size={18} />
          <span>Logout</span>
        </button>
      </div>
    </header>
  );
}

export default Header;
